/**
 *
 */
type DevelopmentFeatureType =
    | "ProvAdvice" // Offer provisioning advice
    | "ProvLock" // Support locking provisioning
    | "InjectAvE" // Inject fake actual-vs-expected filter data
    | "AddMultiSite" // Support adding multiple sites

/**
 * To use this:
 *
 * 1. VUE_APP_ENABLE_DEVELOPMENT_FUNCTION_TOGGLE must be TRUE on build
 * 2. localStorage.getItem(`develFeat${name}`) must be true (eg, 1)
 */
export class DevelopmentFeature {
    /**
     *
     */
    static runtimeEnabled = false
    /**
     *
     */
    static get enabled() {
        return this.runtimeEnabled &&
            !!process.env.VUE_APP_ENABLE_DEVELOPMENT_FUNCTION_TOGGLE
    }
    /**
     *
     * @param name
     * @returns
     */
    static has(name: DevelopmentFeatureType) {
        return this.enabled && !!localStorage.getItem(`develFeat${name}`)
    }
}